import Vue from 'vue'
import App from './funnel_order/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const funnelBuilder = document.getElementById('funnel-index');

  if (funnelBuilder) {
    new Vue({
      el: '#funnel-index',
      render: h => h(App)
    }).$mount();
  }
});